import React, { useState, useEffect } from 'react';

import ReactLoading from 'react-loading';

import {
  getSumMonthBenchmarks, getAvgMonthBenchmarks, getSumWeekBenchmarks,
  getAvgWeekBenchmarks, getSumDayBenchmarks, getAvgDayBenchmarks,
  getAllAgencies, getUser, getUserAgency,
  getGroups
} from '../API.js';

import {
  handleDayTypeClick,
  handleMultiPeriodClick,
  checkFilterCookies,
  updateFilterCookies,
  deleteFilterCookies
} from '../helpers/filterHelpers.js'

import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import TuneIcon from '@mui/icons-material/Tune';
import ClearIcon from '@mui/icons-material/Clear';

import optc from '../optc.json'

import { translateAll, revertOne } from '../helpers/benchmarkHelpers.js'

import BenchmarksDrawer from '../components/Drawers/BenchmarksDrawer.js';
import FilterCard from '../components/Dashboard/FilterCard.js';

import {
  ComposedChart,
  CartesianGrid, Bar, Line,
  XAxis, YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';


import { useTranslation } from "react-i18next";

function Benchmarks() {

  const { t } = useTranslation('common');

  //kpis
  const [dailySumTrends, setDailySumTrends] = useState([]);
  const [weeklySumTrends, setWeeklySumTrends] = useState([]);
  const [monthlySumTrends, setMonthlySumTrends] = useState([]);

  const [dailyAvgTrends, setDailyAvgTrends] = useState([]);
  const [weeklyAvgTrends, setWeeklyAvgTrends] = useState([]);
  const [monthlyAvgTrends, setMonthlyAvgTrends] = useState([]);

  //Filters
  //const [service, setService] = useState(checkFilterCookies()[0].service ? checkFilterCookies()[0].service : 'tous');
  const [service, setService] = useState('tous');
  //const [period, setPeriod] = useState(checkFilterCookies()[0].period ? checkFilterCookies()[0].period : ['all']);
  const [period, setPeriod] = useState(['all']);

  //Agency groups
  const [groups, setGroups] = useState('');
  const [prevGroups, setPrevGroups] = useState('');

  //graph series
  const [selectedSeries, setSelectedSeries] = useState([]);
  const [selectedAvgSeries, setSelectedAvgSeries] = useState([]);
  const [dataKey, setDataKey] = useState('month');
  const [alignedSeries, setAlignedSeries] = useState('');

  const [agency, setAgency] = useState('');
  const [userAgency, setUserAgency] = useState('');

  const [kpiKeys, setKpiKeys] = useState([]);
  const [selectedKey, setSelectedKey] = useState('rtvehhours');
  const [translatedKey, setTranslatedKey] = useState(t('dashboard.kpi.aveh-h'));

  const [monthToggle, setMonthToggle] = useState('contained');
  const [weekToggle, setWeekToggle] = useState('outlined');
  const [dayToggle, setDayToggle] = useState('outlined');

  const [loading, setLoading] = useState(0);
  const [recalcAvg, setRecalcAvg] = useState(false);

  const [open, setOpen] = useState(false);

  //Filter cards
  const [serviceV, setServiceV] = useState('');
  const [periodV, setPeriodV] = useState('');
  const [groupsV, setGroupsV] = useState('');


  // //Translate filters from cookies
  // useEffect(() => {

  //   let serviceCookie = checkFilterCookies()[0].service;
  //   let periodCookie = checkFilterCookies()[0].period;

  //   //Set card value for service
  //   if (serviceCookie && (serviceCookie == 'tous' || serviceCookie == 'all' || serviceCookie == t('compareperiods.all'))) {
  //     setServiceV(t('compareperiods.all'))
  //   } else if (serviceCookie && (serviceCookie == 'se' || serviceCookie == t('compareperiods.week'))) {
  //     setServiceV(t('compareperiods.week'))
  //   } else if (serviceCookie && (serviceCookie == 'fds' || serviceCookie == t('compareperiods.weekends'))) {
  //     setServiceV(t('compareperiods.weekends'))
  //   } else {
  //     setServiceV(t('compareperiods.all'))
  //   }

  //   //Set card value for period
  //   let periodFormat = [];

  //   if (periodCookie && typeof periodCookie !== 'string') {
  //     periodCookie.forEach((e) => {
  //       console.log(e)
  //       switch (e) {
  //         case 'all':
  //           periodFormat.push(' ' + t('compareperiods.all'));
  //           break
  //         case 'morning':
  //           periodFormat.push(' ' + t('compareperiods.morning'));
  //           break
  //         case 'am':
  //           periodFormat.push(' ' + t('compareperiods.am'));
  //           break
  //         case 'offpeak':
  //           periodFormat.push(' ' + t('compareperiods.offpeak'));
  //           break
  //         case 'pm':
  //           periodFormat.push(' ' + t('compareperiods.pm'));
  //           break
  //         case 'evening':
  //           periodFormat.push(' ' + t('compareperiods.evening'));
  //           break
  //       }
  //     })
  //   } else if (periodCookie) {
  //     switch (periodCookie) {
  //       case 'all':
  //         periodFormat.push(' ' + t('compareperiods.all'));
  //         break
  //       case 'morning':
  //         periodFormat.push(' ' + t('compareperiods.morning'));
  //         break
  //       case 'am':
  //         periodFormat.push(' ' + t('compareperiods.am'));
  //         break
  //       case 'op':
  //         periodFormat.push(' ' + t('compareperiods.offpeak'));
  //         break
  //       case 'pm':
  //         periodFormat.push(' ' + t('compareperiods.pm'));
  //         break
  //       case 'evening':
  //         periodFormat.push(' ' + t('compareperiods.evening'));
  //         break
  //     }
  //   } else {
  //     periodFormat = t('compareperiods.all')
  //   }

  //   setPeriodV(periodFormat);

  // }, [])


  useEffect(() => {

    //POURRAIT ETRE OPTIMISE NORMALMEENT PAS BESOIN DE ROULER userAgency EN PREMIER...
    getUserAgency().then((res) => {

      setUserAgency(optc.optc.find((e) => e.operateur == res[0]).groupe);

      //filter active agencies on graph
      getGroups().then((response) => {
        if (prevGroups) {
          response.forEach((e) => {
            if (prevGroups.find((f) => { return e.groupe == f.groupe }).active == true) {
              e.active = true
            } else {
              e.active = false
            }
          })
        } else {
          if (res == 'admin') {
            response.forEach((e) => {
              if (e.groupe == 'stm') {
                e.active = true
              } else {
                e.active = false
              }
            })
          } else {
            response.forEach((e) => {
              if (e.groupe == optc.optc.find((e) => e.operateur == res[0]).groupe) {
                e.active = true
              } else {
                e.active = false
              }
            })
          }
        }
        // Add colors
        let filteredGroups = [];
        response.forEach((e) => {
          e.color = optc.optc.find((f) => f.groupe == e.groupe).color
          filteredGroups.push(e)
        })
        setGroups(filteredGroups);
        //setRefreshKey1(oldKey => oldKey + 1);
      })

    })
  }, [])

  //Get agencies
  useEffect(() => {

    // getAllAgencies()
    //   .then(response => {
    //     setAgencies(response);
    //   })
    // getUser()
    //   .then(response => {
    //     setUser(response.user);
    //   })

    getUserAgency()
      .then(response => {
        setUserAgency(response);
      })

  }, []);


  //Get avgs (once)
  useEffect(() => {

    Promise.all([
      getAvgMonthBenchmarks(service, period),
      getAvgWeekBenchmarks(service, period),
      getAvgDayBenchmarks(service, period)
    ])
      .then(([
        monthResponse,
        weekResponse,
        dayResponse
      ]) => {

        setMonthlyAvgTrends(monthResponse);
        setWeeklyAvgTrends(weekResponse);
        setDailyAvgTrends(dayResponse);

        if (dataKey == 'month') {
          setSelectedAvgSeries(monthResponse);
        }
        else if (dataKey == 'week') {
          setSelectedAvgSeries(weekResponse);
        }
        else if (dataKey == 'day') {
          setSelectedAvgSeries(dayResponse);
        }

      })

  }, []);


  //Get sums (on filter)
  const getSums = () => {

    setLoading(1);

    Promise.all([
      getSumMonthBenchmarks(groups, service, period),
      getSumWeekBenchmarks(groups, service, period),
      getSumDayBenchmarks(groups, service, period)
    ])
      .then(([
        monthResponse,
        weekResponse,
        dayResponse
      ]) => {

        // KPIs
        let kpiKeys = Object.keys(monthResponse[0]);
        kpiKeys.splice(0, 2);
        let translated = translateAll(kpiKeys, t);
        setKpiKeys(translated);

        // // Month data
        setMonthlySumTrends(monthResponse);

        // // Week data
        setWeeklySumTrends(weekResponse);

        // // Day data
        setDailySumTrends(dayResponse);

        // Set corresponding data
        if (dataKey == 'month') {
          setSelectedSeries(monthResponse);
          let graphData = alignData(monthResponse, selectedAvgSeries, selectedKey);
          setAlignedSeries(graphData);
        }
        else if (dataKey == 'week') {
          setSelectedSeries(weekResponse);
          let graphData = alignData(weekResponse, selectedAvgSeries, selectedKey)
          setAlignedSeries(graphData);
        }
        else if (dataKey == 'day') {
          setSelectedSeries(dayResponse);
          let graphData = alignData(dayResponse, selectedAvgSeries, selectedKey)
          setAlignedSeries(graphData);
        }

        setLoading(0);
      })
      .catch(error => {
        // Handle error
        console.error("Error fetching data:", error);
      });
  }


  function handleKPISelect(e) {
    let result = revertOne(e.target.value, t);
    setTranslatedKey(e.target.value);
    setSelectedKey(result);
    let graphData = alignData(selectedSeries, selectedAvgSeries, result);

    setAlignedSeries(graphData);

  }


  //Align sums and avg in case some agencies don't have data for certain days/weeks/months
  function alignData(sumSeries, avgSeries, key) {

    const agencyData = [];

    groups.forEach((f) => {
      let alignedData = [];
      if (f.active == true) {
        avgSeries.forEach((i) => {
          let date = i.chartlabel;
          let val1 = i[key];
          let val2 = sumSeries.find((e) => e.chartlabel === i.chartlabel && e.groupe == f.groupe) ? sumSeries.find((e) => e.chartlabel === i.chartlabel && e.groupe == f.groupe)[key] : 0;
          //let variation = sumSeries.find((e) => e.chartlabel === i.chartlabel) ? sumSeries.find((e) => e.chartlabel === i.chartlabel)[key + '_pct'] : 0;
          let color = f.color
          let groupe = f.groupe;
          alignedData.push({
            date: date,
            value1: val1,
            value2: val2,
            //variation: variation,
            color,
            groupe
          })
        })
        agencyData.push(alignedData);
      }

    })

    return agencyData

  }

  const handleCheckToggleOp = (e) => {

    let groupList = [...groups];
    let groupSelected = groupList.find((f) => { return f.groupe == e.target.value });

    if (groupSelected.active == false) {
      groupList.find((f) => { return f.groupe == e.target.value }).active = true
    } else {
      groupList.find((f) => { return f.groupe == e.target.value }).active = false
    }

    setGroups(groupList);
    //setRefreshKey2(oldKey => oldKey + 1);
  }

  function setMonthlySeries() {
    setSelectedSeries(monthlySumTrends);
    setSelectedAvgSeries(monthlyAvgTrends);
    setDataKey('month');
    let graphData = alignData(monthlySumTrends, monthlyAvgTrends, selectedKey);
    setAlignedSeries(graphData);
  };

  function setWeeklySeries() {
    setSelectedSeries(weeklySumTrends);
    setSelectedAvgSeries(weeklyAvgTrends);
    setDataKey('week');
    let graphData = alignData(weeklySumTrends, weeklyAvgTrends, selectedKey);
    setAlignedSeries(graphData);
  };

  function setDailySeries() {
    setSelectedSeries(dailySumTrends);
    setSelectedAvgSeries(dailyAvgTrends);
    setDataKey('day');
    let graphData = alignData(dailySumTrends, dailyAvgTrends, selectedKey);
    setAlignedSeries(graphData);
  };


  function handleAggToggle(e) {
    if (e.target.id == 'Month') {
      setMonthToggle('contained');
      setWeekToggle('outlined');
      setDayToggle('outlined');
      setMonthlySeries();
    } else if (e.target.id == 'Week') {
      setMonthToggle('outlined');
      setWeekToggle('contained');
      setDayToggle('outlined');
      setWeeklySeries();
    } else {
      setMonthToggle('outlined');
      setWeekToggle('outlined');
      setDayToggle('contained');
      setDailySeries();
    }
  }


  function handleAgencySelect(e) {
    setAgency(e.target.value);
    setMonthToggle('contained');
    setWeekToggle('outlined');
    setDayToggle('outlined');
    setMonthlySeries();
    setRefreshKey(oldKey => oldKey + 1);
    setRefreshKey2(oldKey => oldKey + 1);
  }


  const clearFilters = () => {

    // setPeriod('tous');
    setService('tous');
    setPeriod('all');
    setService('tous');

    setAlignedSeries([]);
    setMonthlySumTrends([]);
    setKpiKeys([]);

    setServiceV(t('compareperiods.all'));
    setPeriodV(t('compareperiods.all'));
    setGroupsV('');

    deleteFilterCookies();
    //setRefreshKey(oldKey => oldKey + 1);

  };

  const handleToggle = () => {
    setOpen(!open)
  };


  const handleFilters = () => {

    //Handle filter visual updates

    //Translate service filter box
    setServiceV(service == 'tous' ? t('compareperiods.all') :
      service == 'se' ? t('compareperiods.week') :
        t('compareperiods.weekends'));

    //Translate period filter box
    let periodFormat = [];
    if (period && typeof period !== 'string') {
      period.forEach((e) => {
        switch (e) {
          case 'all':
            periodFormat.push(' ' + t('compareperiods.all'));
            break
          case 'morning':
            periodFormat.push(' ' + t('compareperiods.morning'));
            break
          case 'am':
            periodFormat.push(' ' + t('compareperiods.am'));
            break
          case 'offpeak':
            periodFormat.push(' ' + t('compareperiods.offpeak'));
            break
          case 'pm':
            periodFormat.push(' ' + t('compareperiods.pm'));
            break
          case 'evening':
            periodFormat.push(' ' + t('compareperiods.evening'));
            break
        }
      })
    } else if (period) {
      switch (period) {
        case 'all':
          periodFormat.push(' ' + t('compareperiods.all'));
          break
        case 'morning':
          periodFormat.push(' ' + t('compareperiods.morning'));
          break
        case 'am':
          periodFormat.push(' ' + t('compareperiods.am'));
          break
        case 'offpeak':
          periodFormat.push(' ' + t('compareperiods.offpeak'));
          break
        case 'pm':
          periodFormat.push(' ' + t('compareperiods.pm'));
          break
        case 'evening':
          periodFormat.push(' ' + t('compareperiods.evening'));
          break
      }
    } else {
      periodFormat = t('compareperiods.all')
    }

    setPeriodV(periodFormat);

    let activeGroups = [];
    groups.forEach((e) => {
      if (e.active == true) {
        activeGroups.push(' ' + e.groupe.toUpperCase());
      }
    })
    setGroupsV(activeGroups);

    //Update filter cookies
    updateFilterCookies(service, period);

    getSums();

  }


  const CustomTooltip = ({ active, payload }) => {

    if (active, payload[0]) {
      return (
        <div className="custom-tooltip">
          <div className="label">
            {payload[0] ? dataKey == 'day' ? t('trends.hover.day') : dataKey == 'week' ? t('trends.hover.week') : t('trends.hover.month') : ''}
            {payload[0] ? payload[0].payload.date : ''}<br />
            {payload.map((e) => (
              e.name !== t('trends.avg') ? (
                <div key={e.payload.groupe}>
                  {e.payload.groupe} : {
                    translatedKey == t('dashboard.kpi.occ') ? e ? e.value.toFixed(2) : '' :
                      translatedKey == t('dashboard.kpi.otp') ? (e.value*100).toFixed(1) + '%' : translatedKey == t('dashboard.kpi.hpct') || translatedKey == t('dashboard.kpi.kmpct') || translatedKey == t('dashboard.kpi.tripspct') ? e ? (e.value).toFixed(1) + '%' : '' :
                        Math.round(e ? e.value : '').toLocaleString('fr-CA')}<br />
                </div>)
                : ''
            ))}
            {payload.map((e) => (
              e.name == t('trends.avg') ? (
                <div key='avg'>
                  {t('trends.avg')} : {
                    translatedKey == t('dashboard.kpi.occ') ? e ? e.value.toFixed(2) : '' :
                      translatedKey == t('dashboard.kpi.otp') || translatedKey == t('dashboard.kpi.hpct') || translatedKey == t('dashboard.kpi.kmpct') || translatedKey == t('dashboard.kpi.tripspct') ? e ? (e.value).toFixed(1) + '%' : '' :
                        Math.round(e ? e.value : '').toLocaleString('fr-CA')}<br />
                </div>)
                : ''
            ))}
          </div>
        </div>
      );
      // If 1 series (sum only)
    }

    return null;
  }


  const renderLegend = (value, entry, index) => {
    return <span style={{ color: "black" }} className="text-color-class">{
      entry.value == t('trends.avg') ?
        // t('trends.avg') + ' ' + translatedKey.toLowerCase() :
        t('trends.avg') + ' ' + t('benchmarks.allagencies') :
        entry.payload.data[0].groupe
    }</span>
  };


  return (
    groups !== '' ?
      <>

        <div className="row justify-content-center ps-1 pe-1">
          <div className="col-sm">
            <h1 id="page-title" className="display-5">{t('benchmarks.title')}</h1>
            {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="row justify-content-center mb-2">
              <h3 id="page-subtitle" className="display-5"><b>{agency != '' ? agency.toUpperCase() : userAgency[0].toUpperCase()}</b> </h3>
            </div> : ''}
          </div>
        </div>

        <div className="container" style={{ backgroundColor: "#f8f9fa" }}>

          <BenchmarksDrawer
            toggle={handleToggle}
            open={open}

            service={service}
            handleDayTypeClick={handleDayTypeClick}

            period={period}
            handleMultiPeriodClick={handleMultiPeriodClick}

            handleFilters={handleFilters}

            setService={setService}
            setPeriod={setPeriod}

            groups={groups}
            handleToggle={handleCheckToggleOp}
            properties={optc.optc}

            setRecalcAvg={setRecalcAvg}
            t={t}
          />

          <div className="row justify-content-center align-items-center pt-3 pb-2">

            {Array.isArray(userAgency) && userAgency.length > 1 ?
              <div className="col-lg-3 col-sm-12">
                <select onChange={(event) => handleAgencySelect(event)} className="form-select form-select-lg mb-3 mt-3">
                  <option defaultValue>Opérateur</option>
                  {userAgency.map((e) => (
                    <option value={e} key={e}
                    >{e}</option>
                  ))}
                </select>
              </div>
              : ''}


            {kpiKeys.length > 0 ? <div className="col-lg-4 col-sm-12 text-center">
              <select onChange={(event) => handleKPISelect(event)} className="form-select form-select-lg mb-3 mt-3">
                {kpiKeys.map((e) => (
                  <option value={e} key={e}
                  >{e}</option>
                ))}
              </select>
            </div>
              : ''}

          </div>

          <div className="row row-cols-1 row-cols-md-3 g-4 pb-3 justify-content-center">
            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={serviceV}
                kpi2={''}
                desc={t('compareperiods.days')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={periodV !== t('compareperiods.all') ? periodV.length>1 ? periodV.join(',') : periodV : periodV}
                kpi2={''}
                desc={t('compareperiods.period')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={groupsV.length > 0 ? groupsV.join(',') : ''}
                kpi2={''}
                desc={t('benchmarks.agencies')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2 text-center">
            <ButtonGroup orientation="vertical" aria-label="Vertical button group">
                <Button
                  variant="outlined"
                  onClick={handleToggle}
                  disableElevation
                  startIcon={<TuneIcon />}
                  //sx={ { borderRadius: 28 } }
                  style={{ fontWeight: "bold", borderColor: "#dee2e6", backgroundColor: "grey", color: "white" }}>
                  {t('compareperiods.filters')}
                </Button>
                <Button
                  variant="outlined"
                  onClick={clearFilters}
                  disableElevation
                  startIcon={<ClearIcon />}
                  //sx={ { borderRadius: 28 } }
                  style={{ fontWeight: "bold", borderColor: "#dee2e6", backgroundColor: "red", color: "white" }}>
                  {t('compareperiods.clear')}
                </Button>
                </ButtonGroup>
            </div>
          </div>

          {loading == 0 ? '' :
            <div className="mapspinner">
              <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
            </div>}


          {monthlySumTrends.length > 0 ?

            <div className="row justify-content-center">

              <div className="row justify-content-center pt-2">
                <div className="col text-center">
                  <ButtonGroup variant="outlined" aria-label="outlined primary button group">
                    <Button id="Month" variant={monthToggle} onClick={(e) => handleAggToggle(e)}>{t('trends.month')}</Button>
                    <Button id="Week" variant={weekToggle} onClick={(e) => handleAggToggle(e)}>{t('trends.week1')}</Button>
                    <Button id="Day" variant={dayToggle} onClick={(e) => handleAggToggle(e)}>{t('trends.day')}</Button>
                  </ButtonGroup>
                </div>
              </div>

              <div className="col-lg col-sm-12 pt-3 pb-3">
                <h3 className="text-center pt-2 pb-2">{translatedKey}</h3>

                <div className="me-1 border rounded" style={{ backgroundColor: "white" }}>

                  {alignedSeries.length > 0 ?
                    <ResponsiveContainer width="100%" height={425}>
                      <ComposedChart
                        width={500}
                        height={300}
                        //data={alignedSeries}
                        margin={{
                          top: 5,
                          right: 30,
                          left: 20,
                          bottom: 90,
                        }}
                      >
                        <CartesianGrid vertical={false} strokeDasharray="3 3" />

                        <XAxis
                          xAxisId={0} dx={-5} textAnchor="end" dataKey="date"
                          tickLine={true} tick={{ fontSize: 13, angle: -90 }}
                          allowDuplicatedCategory={false}
                        />
                        <YAxis allowDataOverflow={false} />
                        <Tooltip
                          content={<CustomTooltip />}
                        />

                        {//Sum series
                          alignedSeries.map((e) => (
                            <Line
                              key={e[0].groupe}
                              dot={{ stroke: e[0].color, strokeWidth: 2, r: 3, fill:'white'}}
                              dataKey="value2"
                              data={e}
                              fill={e[0].color}
                              stroke={e[0].color}
                              strokeWidth={3}
                              isAnimationActive={false}
                              legendType="circle"
                              // label={
                              //   <CustomizedLabel />
                              // }
                              name={translatedKey}
                            />
                          ))
                        }

                        {//Avg series
                        //alignedSeries.length>1 ?
                        <Line
                          dot={{ stroke: "#000000", strokeWidth: 2, r: 3, fill:'white'}}
                          data={alignedSeries[0]}
                          dataKey="value1"
                          fill="#000000"
                          stroke="#000000"
                          strokeWidth={3}
                          isAnimationActive={false}
                          legendType="circle"
                          name={t('trends.avg')}
                        /> //: ''
                        }

                        <Legend
                          verticalAlign="bottom"
                          wrapperStyle={{
                            bottom: '5%',
                            right: '0%',
                          }}
                          formatter={(value, entry, index) =>
                            renderLegend(value, entry, index)
                          } />

                      </ComposedChart>
                    </ResponsiveContainer>
                    : ''}
                </div>
              </div>


            </div>
            : ''}

        </div>
      </> :
      <>
        <div className="container" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="d-flex justify-content-center">
            <div className="row">
              <div className="col-sm">
                <h1 className="display-5">{t('data.loading')}</h1>
                <div className="d-flex justify-content-center">
                  <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>

  )

}

export default Benchmarks